<template>
  <SlideOutContainerViaPortal v-if="isShowingNewUserInvite" :loading="isInviteUserLoading">
    <div>
      <InviteUser @close="hideNewUserInvite" @loadingChange="handleInviteUserLoadingChange" />
    </div>
  </SlideOutContainerViaPortal>
  <SlideOutContainerViaPortal v-else-if="isShowingAddNewUserProfile" :loading="isNewUserProfileLoading">
    <div>
      <NewUserProfile @close="hideAddNewUserProfile" @loadingChange="handleNewUserProfileLoadingChange" :isPage="false" />
    </div>
  </SlideOutContainerViaPortal>
  <section v-else class="search-by-skill-container full-height-page-wrapper">
    <PageHeader page-title="Users">
      <template #buttons>
        <b-button class="button" variant="primary" @click="showNewUserInvite"
          style="outline: none !important; box-shadow: none !important;">
          Invite user
        </b-button>
        <b-button class="button" variant="success" @click="showAddNewUserProfile"
          style="outline: none !important; box-shadow: none !important;">
          Add user profile
        </b-button>
        <b-button class="button title-container__controls-item" :variant="isShowFilter ? 'info' : 'secondary'"
          @click="toggleShowFilter">
          <span class="material-icons icon-image-preview">
            tune
          </span>
          Filters
        </b-button>
      </template>
    </PageHeader>

    <Filters v-show="isShowFilter" textButtonSubmit="Filter" :data="filters" resetToInitial withGroups
      :isLoading="isLoading" @submit="onFilter" @reset="clearSkill" ref="filter">
      <template v-slot:skills="slotProps">
        <div class="skill-dropdown-container">
          <b-form-group>
            <label class="form__label">{{ slotProps.data.data.label }}</label>
            <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="skill ? skill.name : null">
              <multiselect v-model="skill" :options="skills" track-by="id" label="name" :allow-empty="false"
                :showLabels="false" :class="{ 'multiselect__single-line': true }">
              </multiselect>
            </div>
          </b-form-group>
        </div>
        <div class="skill-dropdown-container">
          <b-form-group>
            <label class="form__label">Select skill level</label>
            <div v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }" :title="skill_value">
              <multiselect v-model="skill_value" :options="skillValueOptions" :allow-empty="false" :showLabels="false" :class="{ 'multiselect__single-line': true }">
                <template #option="props">
                  <span class="material-icons star">star</span>
                  <span>{{ props.option }}</span>
                </template>
                <template #singleLabel="props">
                  <span class="material-icons star">star</span>
                  <span class="skill-level-text">{{ props.option }}</span>
                </template>
              </multiselect>
            </div>
          </b-form-group>
        </div>
        <div class="add-skill-button-container">
          <b-button class="button btn-icon" variant="success" :disabled="disableFilterButton"
            @click="addSkillToFilter(slotProps.data.data)">
            <span class="material-icons">
              add
            </span>
          </b-button>
        </div>
      </template>
    </Filters>
    <DataUsers :isLoading="isLoading" :users="users" :fieldsUserSkills="fieldsUserSkills"
      :isInitialDataLoaded="isInitialDataLoaded" @updateUser="getUserAfterUpdate" @reset-filters="handleResetFilters" />
  </section>
</template>

<script>
import { cloneDeep } from 'lodash'
import DataUsers from './DataUsers'
import Filters from '@components/Filter/Filter'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import SlideOutContainerViaPortal from '@components/transition/SlideOutContainerViaPortal.vue'
import InviteUser from '@pages/InviteUser'
import NewUserProfile from '@pages/NewUserProfile'
import PageHeader from '@components/PageHeader.vue'

export default {
  name: 'SearchBySkill',
  components: {
    DataUsers,
    Filters,
    SlideOutContainerViaPortal,
    InviteUser,
    NewUserProfile,
    PageHeader
  },
  data () {
    return {
      filterShow: false,
      users: null,
      isLoading: false,
      isAllOptionsFilterSet: false,
      isUsersDataLoaded: false,
      isDateChangedFirst: true,
      searchSkills: [],
      skills: [],
      skill: null,
      skill_value: '',
      skillValueOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      least_one: false,
      fieldsUserSkills: [],
      date: {
        can_be_booked_from: null,
        can_be_booked_to: null
      },
      disabledDates: {
        to: null
      },
      filters: {
        groups: {
          availability: {
            name: 'Availability and skills',
            fields: {
              'date_from': {
                type: 'datepicker',
                name: 'can_be_booked_from',
                label: 'Available from',
                disabledDates: { to: new Date(Date.now() - 8640000) },
                format: 'dd/MM/yyyy',
                validation: [
                  { name: 'required' }
                ],
                value: null,
                class: 'col-md-2',
                group: 'availability'
              },
              'date_to': {
                type: 'datepicker',
                name: 'can_be_booked_to',
                label: 'Available to',
                disabledDates: { to: new Date(Date.now() - 8640000) },
                format: 'dd/MM/yyyy',
                validation: [
                  { name: 'required' }
                ],
                value: null,
                class: 'col-md-2',
                group: 'availability'
              },
              'skills': {
                type: 'slot',
                slotName: 'skills',
                name: 'searchSkills',
                label: 'Select skill',
                selectLabel: 'alias',
                valueField: 'id',
                value: [],
                class: 'skills-fieldset pl-0 pr-0',
                group: 'availability'
              },
              'least_one': {
                type: 'switch',
                name: 'least_one',
                label: 'At least one skill',
                value: null,
                class: 'at-least-one-switch',
                group: 'availability'
              }
            }
          },
          users: {
            name: 'Users',
            fields: {
              'users': {
                type: 'multiselect',
                name: 'users',
                label: 'Select user',
                class: 'col-md-2',
                valueField: 'name_with_type',
                selectLabel: 'label',
                options: [],
                value: [],
                group: 'users'
              },
              'user_status': {
                type: 'multiselect',
                name: 'user_status',
                label: 'Select status',
                class: 'col-md-2',
                valueField: 'status',
                selectLabel: 'label',
                options: [{ status: 'all', label: 'All' }, { status: 'active', label: 'Active' }, { status: 'inactive', label: 'Inactive' }, { status: 'invited', label: 'Invited' }],
                value: [{ status: 'active', label: 'Active' }, { status: 'invited', label: 'Invited' }],
                defaultValue: [{ status: 'active', label: 'Active' }, { status: 'invited', label: 'Invited' }],
                group: 'users'
              },
              'users_roles': {
                type: 'multiselect',
                name: 'users_roles',
                label: 'Select role',
                class: 'col-md-2',
                valueField: 'name',
                selectLabel: 'display_name',
                options: [],
                value: [],
                group: 'users'
              },
              'users_type': {
                type: 'select',
                name: 'user_type',
                label: 'User type',
                class: 'col-md-2',
                valueField: 'type',
                selectLabel: 'label',
                options: [{ type: 'all', label: 'All' }, { type: 'user', label: 'User' }, { type: 'user-profile', label: 'User profile' }],
                value: [],
                group: 'users'
              }
            }
          }
        }
      },
      isShowFilter: true,
      isShowingNewUserInvite: false,
      isShowingAddNewUserProfile: false,
      isInviteUserLoading: false,
      isNewUserProfileLoading: false
      // invitationId: null, // TODO TEST DATA for delete after Front-End implement
    }
  },
  computed: {
    ...mapGetters({
      getUserRoles: 'getRoles'
    }),
    disableFilterButton () {
      return !(this.skill && this.skill_value)
    },
    fromDateUTC () {
      if (this.date.can_be_booked_from) {
        return moment.utc(this.date.can_be_booked_from, 'YYYY-MM-DD')
      }
      return Date.now()
    },
    filterFields () {
      const fields = {}
      for (let groupKey in this.filters.groups) {
        let groupFields = this.filters.groups[groupKey].fields
        for (let fieldName in groupFields) {
          fields[fieldName] = groupFields[fieldName]
        }
      }
      return fields
    },
    isInitialDataLoaded () {
      return this.isAllOptionsFilterSet && this.isUsersDataLoaded
    }
  },
  async mounted () {
    await this._toggleDataPageLoading(async () => {
      await this.fetchAllData()
    })
  },
  methods: {
    ...mapActions({
      fetchRoles: 'fetchRoles'
    }),
    async fetchAllData () {
      return Promise.all([
        this.getUsers(),
        this.getSkills(),
        this.fetchRoles()
      ]).then(async () => {
        const dateForRequest = this.prepareDataForGetUsers(this.filterFields)
        this.setAllOptionsFilter()
        await this.searchBySkill(dateForRequest)
      })
    },
    setAllOptionsFilter () {
      this.filters.groups.users.fields.users.options = cloneDeep(this.users)
      this.filters.groups.users.fields.users_roles.options = [
        {
          display_name: 'All',
          name: 'all'
        },
        ...this.getUserRoles
      ]

      this.isAllOptionsFilterSet = true
    },
    getUserAfterUpdate () {
      const filterContainer = this.$refs.filter
      filterContainer.submit()
    },
    prepareDataForGetUsers (preparedFields) {
      const fields = cloneDeep(preparedFields)
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Object.prototype.toString.call(value) === '[object Date]') {
          value = this._toLocalTime(value)
        }

        if (name === 'user_status' && value) {
          value = value.map(el => el.status)
        }
        if (name === 'user_type' && value) {
          value = value.type
        }
        if (name === 'users' && value) {
          for (const i in value) {
            const item = value[i]
            if (item.item_type === 'profile') {
              data['user_profiles'] = data['user_profiles'] ?? []
              data['user_profiles'].push(item.name)
              value.splice(i, 1)
            }
          }
          value = value.map(el => el.name)
        }
        if (name === 'users_roles' && value) {
          value = value.map(el => el.name)
        }

        data[name] = value
      }

      return data
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    clearSkill () {
      this.skill = null
      this.skill_value = ''
    },
    addSkillToFilter (formSkillsValue) {
      // Change value into FormGenerator and update Filter

      const key = 'skills'
      let skill = {
        id: this.skill.id,
        name: this.skill.name,
        value: this.skill_value,
        alias: `${this.skill.name} ${this.skill_value}`
      }

      let formGeneratorContainer = this.$refs.filter.$refs.formGenerator
      let skillValue = formGeneratorContainer.fields.groups.availability.fields[key].value

      const isSimiliarSkill = skillValue.some(item => {
        return item.id === skill.id
      })

      if (isSimiliarSkill) {
        this.$snotify.error('Skill can not be duplicated',
          'Error', this.$store.state.snotify)
        return this.clearSkill()
      }

      formGeneratorContainer.fields.groups.availability.fields[key].value.push(skill)
      formGeneratorContainer.updateItem(key, formSkillsValue)
      this.clearSkill()
    },
    onFilter (data) {
      const dateForRequest = this.prepareDataForGetUsers(data)
      this.searchBySkill(dateForRequest)
    },
    toggleFilter () {
      this.filterShow = !this.filterShow
    },
    addItem () {
      if (this.searchSkills.length > 0) {
        var skill = 'undefined'
        this.searchSkills.find((searchSkill) => {
          if (searchSkill.id === this.skill.id) {
            skill = this.searchSkills.indexOf(searchSkill)
          }
        })
        if (skill !== 'undefined') {
          this.searchSkills.splice(skill, 1)
        }
      }
      this.searchSkills.push({
        id: this.skill.id,
        name: this.skill.name,
        value: this.skill_value
      })
      this.skill = null
      this.skill_value = null
    },

    isDateChanged (e) {
      this.isDateChangedFirst = false
      this.disabledDates.to = e
      this.date.can_be_booked_from = e
      this.date.can_be_booked_to = e
    },

    isDateChangedForSecond (e) {
      this.date.can_be_booked_to = e
    },

    onReset (e) {
      e.preventDefault()
      this.searchSkills = []
      this.date.can_be_booked_from = null
      this.date.can_be_booked_to = null
      this.getUsers()
      this.$nextTick(() => {
        this.show = true
      })
    },
    async searchBySkill (formData) {
      this.isLoading = true
      // can_be_booked_from: "2020-10-29"
      // can_be_booked_to: "2020-10-29"
      // least_one: false
      // searchSkills: []
      // let formData = {
      //   searchSkills: this.searchSkills,
      //   least_one: this.least_one,
      //   can_be_booked_from: this.date.can_be_booked_from ? moment(this.date.can_be_booked_from).format('YYYY-MM-DD') : null,
      //   can_be_booked_to: this.date.can_be_booked_to ? moment(this.date.can_be_booked_to).format('YYYY-MM-DD') : null
      // }
      // if (!this.date.can_be_booked_from) {
      //   delete formData.can_be_booked_from
      //   delete formData.can_be_booked_to
      // }
      return this.axios.post(
        `/api/skill/search`,
        {
          ...formData
        },
        {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        }).then(response => {
        if (response.status === 200) {
          this.fieldsUserSkills = []
          for (let i = 0; i < this.searchSkills.length; i++) {
            this.fieldsUserSkills.push({
              id: this.searchSkills[i].id,
              label: this.searchSkills[i].name
            })
          }
          this.users = this.getWithPrefixedNames(response.data)
        }
      }).catch(err => {
        this.errorNotifications(err)
      }).finally(() => {
        this.isLoading = false
        this.isUsersDataLoaded = true
      })
    },
    getSkills () {
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      }).then(response => {
        this.skills = response.data
      }).catch(err => {
        this.errorNotifications(err)
      })
    },
    getUsers () {
      this.isLoading = true
      return this.axios({
        method: 'post',
        url: '/api/users-and-profiles-with-trashed',
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
        .then(response => {
          this.users = this.getWithPrefixedNames(response.data)
          this.fieldsUserSkills = []
        })
        .catch(console.error)
        .finally(() => {
          this.isLoading = false
        })
    },
    getWithPrefixedNames (users) {
      return users.map(user => {
        user.name_with_type = user.item_type + '_' + user.name
        return user
      })
    },
    showAddNewUserProfile () {
      this.isShowingAddNewUserProfile = true
    },
    hideAddNewUserProfile () {
      this.isShowingAddNewUserProfile = false
    },
    showNewUserInvite () {
      this.isShowingNewUserInvite = true
    },
    hideNewUserInvite () {
      this.isShowingNewUserInvite = false
    },
    handleInviteUserLoadingChange (loading) {
      this.isInviteUserLoading = loading
    },
    handleNewUserProfileLoadingChange (loading) {
      this.isNewUserProfileLoading = loading
    },
    handleResetFilters () {
      if (this.$refs.filter) {
        this.$refs.filter.resetFilter()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.spinner-border {
  position: relative;
  margin-left: 10px;
}

.star {
  position: relative;
  top: 2px;
  font-size: 14px;
}

.skills-select {
  .vs__dropdown-toggle {
    padding: 5px !important;
  }
}

.selected-skill {
  label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.title-container__controls {
  gap: 16px;
}

$addSkillButtonWidth: 42px;
$addSkillButtonMargin: 10px;

.search-by-skill-container {
  :global(.skills-fieldset) {
    flex: 0 0 calc(33.33333333% + $addSkillButtonWidth + $addSkillButtonMargin);
  }

  :global(.skills-fieldset > .form-group > div) {
    display: flex;
  }

  ::v-deep .at-least-one-switch {
    margin-top: 22px;
  }
}

.skill-dropdown-container {
  flex: 0 0 calc(50% - ($addSkillButtonWidth + $addSkillButtonMargin) / 2);
  padding-left: 5px;
  padding-right: 5px;
  min-width: 0;
  max-width: calc(50% - ($addSkillButtonWidth + $addSkillButtonMargin) / 2);
  width: calc(50% - ($addSkillButtonWidth + $addSkillButtonMargin) / 2);
}

.add-skill-button-container {
  margin: 20px 0 0 $addSkillButtonMargin;
}

.skill-level-select {
  .skill-level-text {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: inline-block !important;
    max-width: calc(100% - 30px) !important;
    vertical-align: top !important;
  }
}
</style>
